
export default {
  path: '2020',
  component: resolve => require(['@/components/common/ViewTemplate'], resolve),
  children: [
    {
      path: 'annals',
      component: resolve => require(['@/components/activities/2020/annals/Annals'], resolve),
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/modules/activities/2020/index.js